import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

interface NavbarProps {
  onNavigate: (sectionId: string) => void;
}

export const Navbar: React.FC<NavbarProps> = ({ onNavigate }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNav = (sectionId: string) => {
    onNavigate(sectionId);
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-6 py-4 bg-white/80 backdrop-blur-lg border-b border-[rgba(11,12,15,0.05)] transition-all">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div 
          className="flex items-center gap-3 cursor-pointer select-none" 
          onClick={() => handleNav('hero')}
        >
          <img 
            src="/images/logo-icon.png" 
            alt="UV Pulser Logo" 
            className="w-10 h-10 object-contain"
            loading="eager"
          />
          <div className="flex flex-col">
            <span className="text-xl font-semibold tracking-tight text-slate-900 leading-tight">UV Pulser</span>
            <span className="text-[10px] tracking-wider text-cyan-600 font-mono font-medium uppercase">an aFoundry venture</span>
          </div>
        </div>
        
        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-7">
          <button onClick={() => handleNav('consumer')} className="text-sm font-medium text-[#6B7280] hover:text-[#0B0C0F] transition-colors">Consumer</button>
          <button onClick={() => handleNav('industrial')} className="text-sm font-medium text-[#6B7280] hover:text-[#0B0C0F] transition-colors">Industrial</button>
          <button onClick={() => handleNav('tech')} className="text-sm font-medium text-[#6B7280] hover:text-[#0B0C0F] transition-colors">Technology</button>
          <button onClick={() => handleNav('specs')} className="text-sm font-medium text-[#6B7280] hover:text-[#0B0C0F] transition-colors">Specs</button>
          <button onClick={() => handleNav('investor')} className="text-sm font-semibold text-[#06B6D4] hover:text-[#0891B2] transition-colors px-3 py-1 rounded-full bg-cyan-50 border border-cyan-200">Invest</button>
          <button onClick={() => handleNav('contact')} className="text-sm font-medium text-[#6B7280] hover:text-[#0B0C0F] transition-colors">Contact</button>
          <button onClick={() => handleNav('contact')} className="uv-btn-primary text-sm shadow-sm hover:shadow-md transition-shadow">Request a Demo</button>
        </div>
        
        {/* Mobile Menu Button */}
        <button 
          className="md:hidden p-2 text-slate-700 hover:text-slate-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500/20"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-slate-100 shadow-xl py-4 px-6 animate-fadeIn">
          <div className="flex flex-col gap-3">
            <button onClick={() => handleNav('consumer')} className="text-left py-2 text-[#0B0C0F] font-medium hover:text-cyan-600 transition-colors">Consumer Modules</button>
            <button onClick={() => handleNav('industrial')} className="text-left py-2 text-[#0B0C0F] font-medium hover:text-cyan-600 transition-colors">Industrial Systems</button>
            <button onClick={() => handleNav('tech')} className="text-left py-2 text-[#0B0C0F] font-medium hover:text-cyan-600 transition-colors">Pulsed UV Technology</button>
            <button onClick={() => handleNav('specs')} className="text-left py-2 text-[#0B0C0F] font-medium hover:text-cyan-600 transition-colors">Technical Specifications</button>
            <button onClick={() => handleNav('investor')} className="text-left py-2 text-[#06B6D4] font-semibold flex items-center justify-between">
              <span>Investment Opportunity</span>
              <span className="text-xs bg-cyan-100 text-cyan-800 px-2 py-0.5 rounded-full">Open</span>
            </button>
            <button onClick={() => handleNav('contact')} className="text-left py-2 text-[#0B0C0F] font-medium hover:text-cyan-600 transition-colors">Contact Engineering</button>
            <button onClick={() => handleNav('contact')} className="uv-btn-primary w-full text-center mt-2">Request a Demo</button>
          </div>
        </div>
      )}
    </nav>
  );
};
